// libs
import { useState, useEffect, useCallback } from 'react'

// check if string is non-whitespace
export const isNonWhitespaceString = (str) => {
    return str && !/^\s*$/.test(str)
}

// check if dom is loaded
export const useDomLoaded = () => {
    const [domLoaded, setDomLoaded] = useState(false)

    useEffect(() => {
        setDomLoaded(true)
    }, [])

    return domLoaded
}

// remove all special characters from phone (to use in href='tel:')
export function phone(str) {
	return (
		'tel:' + str.replace(/[^0-9]/g, '')
	)
}

// simple function to use along <a href='mailto:'>
export function email(str) {
	return (
		'mailto:' + str
	)
}

// slugify
export function slugify(str) {
    return String(str)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
}

// replace spaces
export function replaceSpaces(str) {
    return str.replace(/\s+/g, '-');
}

// calc vw / vh
export const vw = (coef) => window.innerWidth * (coef/100)
export const vh = (coef) => window.innerHeight * (coef/100)

// limit characters
export function limitCharacters(text, limit) {
    if (text.length <= limit) {
        return text
    } else {
        return text.slice(0, limit) + '...'
    }
}

// create a wrapper around tables
export const tableWrapper = () => {
    useEffect(() => {
        const handleDomReady = () => {
            const richTextElements = document.querySelectorAll('.rich-text')
    
            richTextElements.forEach((richTextElement) => {
                const tables = richTextElement.querySelectorAll('table')
    
                tables.forEach((table) => {
                    if (!table.parentElement.classList.contains('table-rich-text')) {
                        const wrapper = document.createElement('div')
                        wrapper.classList.add('table-rich-text')
                        
                        table.parentNode.insertBefore(wrapper, table)
                        wrapper.appendChild(table)
                    }
                })
            })
        }
    
        // wait for the dom to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', handleDomReady)
        } else {
            handleDomReady()
        }
    
        return () => {
            document.removeEventListener('DOMContentLoaded', handleDomReady)
        }
    }, [])
}

// debounce
export function debounce(fn, delay) {
    let timeoutId
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        timeoutId = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

// smooth scroll
export const useSmoothScroll = () => {
    const smoothScrollTo = useCallback((targetId) => {
        const targetElement = document.getElementById(targetId)

        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }, [])

    return smoothScrollTo
}

export const regexSpecialChars = /!|@|#|\$|%|\^|&|\*|\(|\)|\[|\]|\{|\}|'|"|\\|\/|\?|:|;|,|\.|<|>|\+|-|=|_|`|~/g

// get all focusable elements inside the container
export const getFocusableElements = (container) => {
    return container.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )
}

// get all focusable elements outside the container
export const getFocusableElementsOutside = (container) => {
    const allFocusableElements = document.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )

    // filter out elements that are inside the container
    return Array.from(allFocusableElements).filter(
        (element) => !container.contains(element)
    )
}